import React from "react";
import { useAppSelector } from "../../hooks/customReduxHooks";
import modalSlice from "../../redux/data/modal";
import { useDispatch } from "react-redux";
import VideoModal from "../../components/modals/VideoModal/videoModal";
import CategoriaHijos from "../../components/modals/CategoriaHijos/CategoriaHijos";
import ConfirmationModal from "../../components/modals/ConfirmationModal/ConfirmationModal";
import InfoModal from "../../components/modals/InfoModal/InfoModal";
import { MultimediaGalleryModal } from "../../components/product";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { BackgroundModal, BodyModal, TituloModal, ModalContainer, } from "./ModalStyled";
var Modal = function () {
    var _a = useAppSelector(function (state) { return state.modal; }), isOpen = _a.isOpen, type = _a.type, data = _a.data, titulo = _a.titulo, link = _a.link;
    var dispatch = useDispatch();
    var closeModal = modalSlice.actions.closeModal;
    var chooseCorrectType = function () {
        switch (type) {
            case "video":
                return React.createElement(VideoModal, { videos: data });
            case "subCategorias":
                return React.createElement(CategoriaHijos, { categoria: data });
            case "confirmation":
                return React.createElement(ConfirmationModal, { action: data, closeModal: function () { return close(); } });
            case "multimediaGalleryModal":
                return React.createElement(MultimediaGalleryModal, { data: data });
            case "info":
                return React.createElement(InfoModal, { data: data });
            default:
                return "";
        }
    };
    var close = function () {
        if (data === null || data === void 0 ? void 0 : data.closeModal) {
            data.closeModal();
        }
        else {
            dispatch(closeModal());
        }
    };
    return (isOpen && (React.createElement(ModalContainer, null,
        React.createElement(BackgroundModal, { onClick: function () { return close(); } }),
        React.createElement(BodyModal, { type: type },
            React.createElement("button", { onClick: function () { return close(); } },
                React.createElement(FontAwesomeIcon, { icon: faTimes })),
            titulo && (React.createElement(TituloModal, null,
                React.createElement("a", { href: link ? link : "#" }, titulo))),
            chooseCorrectType()))));
};
export default Modal;
